import {
  ApiMasterDataAdvancedQuery,
  ApiMasterDataQuery,
  ApiMasterDataQueryResponse,
} from '../api/api-interfaces';
import { CachedMasterDataService } from '../api/cached-master-data-service';
import { BenchmarkConfig } from '../api/master-data-service';
import { VersionId } from '../v2/api/types';
import { handleGQLErrors } from '../v2/api/utils';
import {
  advancedQueryToCustomSqlQuery,
  oldQueryToAdvancedQuery,
} from './utils';

export const GetResponseForMasterQueryService = async (
  query: ApiMasterDataQuery,
  cachedMasterDataApiService: CachedMasterDataService,
  latestVersionId?: VersionId,
  benchmarkConfig?: BenchmarkConfig
): Promise<ApiMasterDataQueryResponse> => {
  const advancedQuery = oldQueryToAdvancedQuery(query, latestVersionId);
  const sqlQuery = await advancedQueryToCustomSqlQuery(advancedQuery);
  return handleGQLErrors(
    cachedMasterDataApiService.executeCustomSqlQuery(
      advancedQuery.dimensions ?? [],
      advancedQuery.measures ?? [],
      sqlQuery,
      advancedQuery.disableNestLoop
    ),
    {
      request: 'executeCustomSqlQuery',
      query: JSON.stringify(advancedQuery),
    }
  );
};

export const GetResponseForAdvancedQueryService = async (
  query: ApiMasterDataAdvancedQuery,
  cachedMasterDataApiService: CachedMasterDataService,
  _benchmarkConfig?: BenchmarkConfig
) => {
  const sqlQuery = await advancedQueryToCustomSqlQuery(query);
  return handleGQLErrors(
    cachedMasterDataApiService.executeCustomSqlQuery(
      query.dimensions ?? [],
      query.measures ?? [],
      sqlQuery,
      query.disableNestLoop
    ),
    {
      request: 'executeCustomSqlQuery',
      query: JSON.stringify(query),
    }
  );
};
